const fields = {
  client: {
    companyName: "companyName", clientType: "clientTypeId", state: "statusId",
    email: "email", clientManager: "clientManagerId", clientPreset: "clientPresetId",
    comment: "comment", language: "languageId", country: "countryCode",
    legalName: "legalName", businessType: "businessTypeIds", regNo: "regNo",
    address: "address", billAddress: "billAddress", handlingInPlace: "handlingInPlace",
    vatNr: "vat", bank: "bank", accountNo: "accountNo", swift: "swift",
    source: "sourceId", competitor: "competitorsId",
  },
  contact: {
    name: "name", surname: "surname", phoneNumber: "phoneNumber",
    contactEmail: "email", positionType: "positionId", positionName: "positionName",
  },
  invoiceSetting: {
    invoiceVat: "userVat", invoiceCountry: "countryId", paymentType: "paymentTypeId",
    paymentPeriod: "paymentPeriodId", paySubscriptionUntil: "paySubscriptionId",
    pprPaymentTerm: "pprId",
  },
  userInterfaceDetails: {
    currencyId: "currencyId", distanceId: "distanceId", volumeId: "volumeId",
    temperatureId: "temperatureId", weightId: "weightId",
    fuelConsumptionId: "measurementOfFuelConsumptionId",
  },
};

export const buildCustomerUpdatePayload = (
  values: Record<string, unknown>,
  initialValues: Record<string, unknown>,
) => {
  const payload: Record<string, Record<string, unknown>> = {};
  for (const [section, mapping] of Object.entries(fields)) {
    const changes: Record<string, unknown> = {};
    for (const [field, key] of Object.entries(mapping)) {
      if (JSON.stringify(values[field]) === JSON.stringify(initialValues[field])) continue;
      // Undefined is omitted by JSON serialization; null explicitly clears a field.
      changes[key] = values[field] == null ? null
        : field === "invoiceVat" ? values[field] === "true" : values[field];
    }
    if (Object.keys(changes).length > 0) {
      payload[section] = changes;
    }
  }
  return payload;
};
